import { Component, Input, OnInit } from '@angular/core';
import { TRANSLATION_SCOPE } from '../../i18n/scope';

@Component({
  selector: 'app-about-template',
  templateUrl: './about-template.component.html',
  styleUrls: ['./about-template.component.scss']
})
export class AboutTemplateComponent implements OnInit {

  @Input() description: string;
  @Input() descriptionTitle: string;
  
  translationScope = TRANSLATION_SCOPE;
  readMoreText = false;

  constructor() { }

  ngOnInit() {
  }

  readMore(): void {
    this.readMoreText = !this.readMoreText
  }

}
